<template>
  <uni-popup ref="diagnose" type="bottom" @change="changePopup">
    <uni-card :is-full="true" title="添加诊断">
      <div class="out_wrap">
        <!-- 已选列表 -->
        <div class="diag_wrap">
          <div v-for="(item, i) in tempDiagList" :key="i" class="search_result">
            <span :class="{ mdrug: item.symptomType === '3' }">
              {{ item.diseaseName || item.symptomName }}
            </span>
            <span>{{ item.mainCode || item.symptomCode }}</span>
            <span> 【{{ getKeyValueText('symptom_type', item.symptomType) }}】 </span>
            <img
              src="@funcPuzzle/mini_doctor/delete_diag.png"
              class="deleteDiagnose"
              @click="deleteDiagnose(i)"
            />
          </div>
        </div>
        <!-- 搜索-取消 -->
        <div class="search">
          <uni-search-bar
            v-model="value"
            :focus="showSearch"
            bg-color="#f8f8f8"
            placeholder="请搜索诊断（疾病名称/拼音码）"
            :adjust-position="false"
            @confirm="search"
            @oninput="search"
            @blur="blur"
            @cancel="cancel"
          />
        </div>
        <ms-symptom-tabs v-model="activeIndex" class="sticky-box" :list="symptomData" />
        <div class="search_wrap">
          <div v-if="symptomList && symptomList[0]">
            <div
              v-for="(item, i) in symptomList"
              :key="i"
              class="search_result"
              @click="confirmDiagnose(item)"
            >
              <span :class="{ mdrug: item.symptomType === '3' }">
                {{ item.diseaseName }}
              </span>
              <span>{{ item.mainCode || '' }}</span>
              <span> 【{{ getKeyValueText('symptom_type', item.symptomType) }}】 </span>
            </div>
            <div class="blank" />
          </div>
          <gl-no-content v-else :title="'暂无数据'" />
        </div>
      </div>
      <div class="confirm_footer">
        <div class="confirm_btn" @click.stop="confirmAdd">
          <span>确定</span>
        </div>
      </div>
    </uni-card>
  </uni-popup>
</template>

<script>
import { mapState } from 'vuex'
import { getKeyValueText, getKeyValue } from '@/views/funcPuzzle/utils/util.js'
import { aGetSymptomListByCache, getBusinessDicList } from '@/views/funcPuzzle/utils/index.js'
import GlNoContent from '@/views/funcPuzzle/home/components/gl-no-content'
import msSymptomTabs from '../ms-symptom-tabs/ms-symptom-tabs.vue'
import { isTCM } from '@/views/funcPuzzle/utils/business.js'

export default {
  components: {
    GlNoContent,
    msSymptomTabs
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    diagnosisOfType: {
      type: [Object, String, Number],
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isTCM: isTCM(),
      value: '',
      symptomList: [],
      symptomData: [],
      activeIndex: 0,
      symptomType: '',
      showSearch: false
      // tempDiagList: []
    }
  },
  methods: {
    getKeyValueText,
    getKeyValue,
    cancel() {
      this.$refs.diagnose.close()
      this.$bus.emit('diagnoseMsg', [])
    },
    changePopup(e) {
      this.$emit('update:visible', e.show)
    },
    close() {
      if (!this.$refs.diagnose) {
        return false
      }
      this.showSearch = false
      this.$refs.diagnose.close()
    },
    // 查询
    search(val) {
      this.getSymptomListByCache(this.symptomType)
    },
    // 请求接口，获取诊断数据，
    getSymptomListByCache() {
      aGetSymptomListByCache({
        pageNum: '1',
        pageSize: 50,
        symptomType: this.symptomType,
        searchKeyword: this.value || null
      }).then(rs => {
        this.symptomList = rs.SymptomList
      })
    },
    // 点击诊断选项，将当前项添加至列表
    confirmDiagnose(item) {
      // this.$refs.diagnose.close()
      // this.$bus.$emit('diagnoseMsg', item)
      // 0719 新需求，诊断长度限制为20个
      // 长度不大于20时添加
      if (this.tempDiagList.length < 10) {
        // 为导入病例的诊断数据添加 mainCode
        this.tempDiagList.forEach(item => {
          if (!item.mainCode) {
            item.mainCode = item.symptomCode
          }
        })
        // 需要判断code和类型
        const hasRepeat = this.tempDiagList.find(
          i => i.mainCode === item.mainCode && i.symptomType === item.symptomType
        )
        // 有重复的不添加
        if (!hasRepeat) {
          this.tempDiagList.push(item)
        } else {
          uni.showToast({
            icon: 'none',
            title: '该诊断已添加'
          })
        }
      } else {
        uni.showToast({
          icon: 'none',
          title: '最多添加10个'
        })
      }
    },
    // 删除列表中的一项
    deleteDiagnose(i) {
      this.tempDiagList.splice(i, 1)
    },
    // 点击确定按钮，保存
    confirmAdd() {
      this.$refs.diagnose.close()
      this.$bus.emit('diagnoseMsg', this.tempDiagList)
    },
    open() {
      // this.$emit('update:visible', true)
      this.$refs.diagnose.open()
    },
    // 查配置
    getBusinessConfig() {
      let fish = ''
      // 医院是否有中医病历
      if (this.isTCM) {
        switch (this.diagnosisOfType) {
          // this.baseOrgan.getbaseInfo().hospitalID + _2 中医证型
          case 0:
            fish = this.hospitalID + '_2'
            break
          // this.baseOrgan.getbaseInfo().hospitalID + _1 西医证型
          case 1:
            fish = this.hospitalID + '_1'
            break
          default:
            fish = this.hospitalID
            break
        }
      } else {
        fish = this.hospitalID
      }
      // const fish = this.hospitalID

      getBusinessDicList({
        pageNum: 1,
        pageSize: 1,
        tableName: 'enabled_symptom_type',
        code: fish
      }).then(rs => {
        if (!rs.DoctorServicePackageList || !rs.DoctorServicePackageList[0]) return

        const data = JSON.parse(rs.DoctorServicePackageList[0].value)
        data.enabledSymptomType.sort((a, b) => {
          return a.order - b.order
        })

        this.symptomData = []

        data.enabledSymptomType.map(item => {
          const value = this.getOption(item.symptomType)
          this.symptomData = this.symptomData.concat(value)
        })

        this.setSymptomType(this.activeIndex)
      })
    },
    getOption(type) {
      return this.getKeyValue('symptom_type').filter(value => {
        return value.code === type
      })
    },
    setSymptomType(val) {
      if ((val === 0 || val) && this.visible) {
        this.symptomType = this.symptomData.filter((item, index) => {
          return val == index
        })[0].code

        this.getSymptomListByCache(this.symptomType)
      }
    },
    blur() {
      this.showSearch = false
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    },
    selectValue: {
      set(val) {
        this.$emit('input', val)
      },
      get() {
        return this.value
      }
    },
    tempDiagList: {
      get() {
        return this.list
      },
      set(val) {
        this.$emit('update:list', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.value = ''
        this.showSearch = true
        this.activeIndex = 0
        this.$refs.diagnose.open()
        this.getBusinessConfig()
        this.tempDiagList = this.list || []
      } else {
        this.close()
      }
    },
    activeIndex: {
      handler(val) {
        this.setSymptomType(val)
      }
    }
  },
  unmounted() {
    this.$bus.off('diagnoseMsg')
  }
}
</script>

<style scoped></style>
<style lang="scss" scoped>
.out_wrap {
  // max-height: 23.466667rem;
  // min-height: 23.466667rem;
  height: 23.466667rem;
}
.confirm_footer {
  height: 3.370667rem;
  background-color: #fff;
  padding: 0.384rem 0.682667rem 0;
  position: fixed;
  left: 0;
  bottom: 0;
  .confirm_btn {
    height: 1.877333rem;
    color: #0089ff;
    width: 14.634667rem;
    border: 0.021333rem solid #0089ff;
    border-radius: 0.938667rem;
    text-align: center;
    line-height: 1.877333rem;
  }
}
.diag_wrap {
  width: auto;
  max-height: 6.186667rem;
  overflow-y: scroll;
  padding: 0.682667rem;
  padding-bottom: 0;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;

  .search_result {
    width: fit-content;
    // max-height: 1.450667rem;
    border-radius: 0.085333rem;
    border: 0.021333rem solid #0089ff;
    font-size: 0.64rem;
    font-weight: 400;
    color: #0089ff;
    padding: 0.128rem 0.213333rem;
    box-sizing: border-box;
    position: relative;
    margin: 0 0.341333rem 0.682667rem 0;
    .deleteDiagnose {
      position: absolute;
      width: 0.597333rem;
      height: 0.597333rem;
      right: -0.298667rem;
      top: -0.298667rem;
    }
  }
}
.confirm_btn {
  font-size: 0.682667rem;
  font-weight: 400;
  color: #0089ff;
}
.search_wrap {
  overflow-y: scroll;
  overflow-x: hidden;
  /* max-height: 17.493333rem; */
  max-height: 20.693333rem;
  .blank {
    width: 100%;
    max-height: 8.96rem;
    min-height: 8.533333rem;
  }

  .sticky-box {
    width: 100%;
    display: flex;
    top: var(--window-top);
    z-index: 99;
    flex-direction: row;
    margin: 0rem;
  }
  ::v-deep .tab__item {
    width: 5.333333rem !important;
    text-align: center;
    line-height: 1.706667rem;
  }

  ::v-deep .tab__line {
    width: 1.333333rem;
    transform: translateX(1.333333rem) translateX(-50%);
  }
  .search_result {
    width: 100%;
    height: 1.92rem;
    border-bottom: 0.021333rem solid #ececec;
    line-height: 1.92rem;
    padding-left: 0.64rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text {
      margin-right: 0.213333rem;
    }
  }
}
</style>
